import React from "react";
import PropTypes from "prop-types";
import { compose } from 'redux'
import moment from 'moment';
import {Button as FabButton} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles,
    Paper,
    Input,
    Typography,
    FormControl,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    TextField,
    Tooltip,
    InputAdornment,
    Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle, Button as MaterialButton,
    Chip} from "@material-ui/core";
import _ from 'lodash';
import {firestoreConnect, isLoaded} from 'react-redux-firebase'
import { connect } from 'react-redux'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {CustomInput,TextQuestion,ImageQuestion,Button,LoadingSpinner,QuestionTypeSelector,MultipleChoiceQuestion,CheckBoxChoiceQuestion} from "../../components"
import validate from '../../actions/validateWrapper'


var surveyId;
const collection="surveys"
const subCollection="questions"

class EditSurvey extends React.Component {

    state={
        dialogOpen:false,
        isLoading:false,
        survey:{},
        questions:{},
        isSaving:false,
        error:null,
        text:"",
        text1:"",
        text2:"",
        text3:"",
        textError:"",
        textError1:"",
        textError2:"",
        textError3:"",
        currentQuestion:null,
    }

    constructor(props){
        super(props)
        this.addQuestion = this.addQuestion.bind(this)
        this.saveSurvey = this.saveSurvey.bind(this)
        this.renderQuestionType = this.renderQuestionType.bind(this)

        surveyId = this.props.route.match.params.id
    }

    addQuestion(){
        const {firestore,questions} = this.props

        let blankQuestion ={type:"text",index:questions?Object.keys(questions).length:"0"}

        firestore.add({collection:collection,doc:surveyId,subcollections:[{collection:subCollection}]},blankQuestion)
    }

    componentDidUpdate(prevProps) {
        const {survey} = this.state
        const {firestore,history,surveys} = this.props
        const surveydes = this.props.survey.description;
        // Typical usage (don't forget to compare props):
        if (this.props.survey !== prevProps.survey) {
          //this.fetchData(this.props.survey.description);
          //this.setState({survey:prevProps.survey})
          console.log("Props test",this.props.survey.allowSurveyCompletionTimes);
          
        }
        
      }

    saveSurvey(){
        const {survey,questions} = this.state

        const {firestore,history} = this.props

        let promiseArray = []
        
        //const textError = validate('text', this.state.survey.description)
        var textError
        if(survey.description==""){
        textError = validate('text', this.state.survey.description)
        }
        else if(!this.state.text==""){
        textError = validate('text', this.state.text)
        }
        var textError1
        if(survey.reward==""){
        textError1 = validate('text', this.state.survey.reward)
        }
        else if(!this.state.text1==""){
            textError = validate('text', this.state.text1)
        }

        var textError2
        if(survey.allowSurveyCompletionTimes==""){
        textError2 = validate('number', this.state.survey.allowSurveyCompletionTimes)
        }
        else if(!this.state.text2==""){
        textError = validate('text', this.state.text2)
        }

        var textError3
        if(survey.name==""){
        textError3 = validate('text', this.state.survey.name)
        }
        else if(!this.state.text3==""){
        textError = validate('text', this.state.text3)
        }

        this.setState({textError:textError})
        this.setState({textError1:textError1})
        this.setState({textError2:textError2})
        this.setState({textError3:textError3})

        if (!textError&&!textError1&&!textError2&&!textError3) {
        this.setState({isSaving:true})

        firestore.update({collection:collection,doc:surveyId},survey)

        promiseArray.push(firestore.update({collection:collection,doc:surveyId},survey))
            var index = 6;
        _.map(questions,(question,key)=>{
            question.index = question.index?question.index:index
            promiseArray.push(firestore.set({collection:collection,doc:surveyId,subcollections:[{collection:subCollection,doc:key}]},question))
            index++
        })

        Promise.all(promiseArray).then(()=>{
            this.setState({isSaving:false})
            history.push(`/survey/${surveyId}/view`)
        })
    }
  
    }

    renderQuestionType(question,key){

        let reactElement = null;


        const {questions} = this.props;

        switch(question.type){

            case "text":
            default:
            reactElement =
                    <TextQuestion inputProps={
                        {
                            defaultValue: question.prompt,
                            onChange: (event)=>{
                                let question = questions[key];
                                question.prompt = event.target.value
                                questions[key] =question
                                this.setState({questions:questions})}

                        }}
                                  isShortAnswer={question.isShortAnswer}

                                  onTypeChange={ (typeChange)=>{

                                      let question = questions[key];
                                      question.isShortAnswer = typeChange;
                                      questions[key] =question
                                      this.setState({questions:questions})
                                  }}

                    />

                break;
                case "image":
                    reactElement =
                            <ImageQuestion inputProps={
                                {
                                    defaultValue: question.prompt,
                                    onChange: (event)=>{
                                        let question = questions[key];
                                        question.prompt = event.target.value
                                        questions[key] =question
                                        this.setState({questions:questions})}

                                }}
                                        isShortAnswer={question.isShortAnswer}

                                        onTypeChange={ (typeChange)=>{

                                            let question = questions[key];
                                            question.isShortAnswer = typeChange;
                                            questions[key] =question
                                            this.setState({questions:questions})
                                        }}

                            />

                        break;
            case "multiple":
                reactElement= <MultipleChoiceQuestion
                                key={key}
                                prompt={question.prompt}
                                options={question.options}
                                onOptionAdd={()=>{
                                    questions[key].options?questions[key].options.push(""):questions[key].options=[""];
                                    this.setState({questions:questions})
                                }}

                                promptInputProps={{
                                    defaultValue:question.prompt,
                                    onChange:(event)=>{
                                        questions[key].prompt = event.target.value;
                                        this.setState({questions:questions})
                                    }

                                }}

                                onOptionValueChange={
                                    (event,index)=>{
                                        questions[key].options[index] = event.target.value;
                                        this.setState({questions:questions})
                                    }
                                }

                                onOptionDelete={(index)=>{
                                    questions[key].options.splice(index,1)
                                    this.setState({questions:questions})
                                }
                                }
                />

            break;
            case "checkbox":
            reactElement= <CheckBoxChoiceQuestion
                            key={key}
                            prompt={question.prompt}
                            options={question.options}
                            onOptionAdd={()=>{
                                questions[key].options?questions[key].options.push(""):questions[key].options=[""];
                                this.setState({questions:questions})
                            }}

                            promptInputProps={{
                                defaultValue:question.prompt,
                                onChange:(event)=>{
                                    questions[key].prompt = event.target.value;
                                    this.setState({questions:questions})
                                }

                            }}

                            onOptionValueChange={
                                (event,index)=>{
                                    questions[key].options[index] = event.target.value;
                                    this.setState({questions:questions})
                                }
                            }

                            onOptionDelete={(index)=>{
                                questions[key].options.splice(index,1)
                                this.setState({questions:questions})
                            }
                            }
            />

        break;
        }
        return reactElement
    }


    deleteEmptyQuestion=()=>{
        const {firestore,survey,userAnswers,questions} = this.props
        console.log(this.state.currentQuestion)
            if(this.state.currentQuestion !== null){
                 firestore.delete({collection:"surveys",doc:surveyId, subcollections: [{ collection: 'questions', doc: this.state.currentQuestion }]})
            }
         this.setState({isLoading:false})
         this.setState({dialogOpen:false,currentQuestion:null})
    }

    openDeleteModal = (question) => {
        this.setState({ dialogOpen: true ,currentQuestion:question});
    };

    handleClose = () => {
        this.setState({ dialogOpen: false,currentQuestion:null });
    };


    render() {

        const {classes,survey,questions,userAnswers} = this.props
        const {isSaving,error} = this.state

        let questionIndex=0;
        console.log("Answers", userAnswers);



        return(
            <div className={classes.root}>
                {isLoaded(survey)&&!isSaving?
                <Paper className={classes.paperContainer}>

                    <div className={classes.questionContainer}>
                <FormControl fullWidth={true}
                    //   {...formControlProps}
                    //   className={formControlProps.className + " " + classes.formControl}
                    >
                        <Input
                            style={{color:"#fc824e"}}
                            defaultValue={survey&&survey.name?survey.name:"Untitled Campaign"}
                            className={classes.surveyHeaderInput}
                            inputProps={{
                                'aria-label': 'Campaign Title',
                                onChange:(event)=>{
                                    let survey = this.state.survey
                                    survey.name = event.target.value
                                    let text3 = event.target.value
                                    this.setState({survey:survey,
                                    text3:text3,
                                    textError3: validate('text', this.state.survey.name)
                                    })}
                                    
                            }}
                            //error={this.state.textError3}
                            
                        />
                        {this.state.textError3 ? <Typography style={styles.errorColor}>{this.state.textError3}</Typography> : null}
                        </FormControl>

                      <CustomInput
                        labelText="Campaign Description"
                        inputProps={{
                            defaultValue:survey&&survey.description?survey.description:"",
                            'aria-label': 'Campaign Description',
                            onChange:(event)=>{
                                console.log("survey in desc",survey);
                                let survey = this.state.survey
                                survey.description= event.target.value
                                let text = event.target.value
                                this.setState({survey:survey,
                                    text : text,
                                    textError: validate('text', this.state.survey.description)
                                })},
                                // onBlur:() => {
                                //     this.setState({
                                //         textError: validate('text', this.state.survey.description)
                                //     })
                                // }
                        }}

                        formControlProps={{
                            fullWidth: true
                        }}
                        error={this.state.textError}
                    />
                        <CustomInput
                            labelText="Campaign Reward"
                            inputProps={{
                                defaultValue:survey&&survey.reward?survey.reward:0,
                                'aria-label': 'Campaign Rewards',
                                startAdornment:<InputAdornment position="start">R</InputAdornment>,
                                onChange:(event)=>{
                                    let survey = this.state.survey
                                    survey.reward= event.target.value
                                    let text1 = event.target.value
                                    this.setState({survey:survey,
                                    text1 : text1,
                                    textError1: validate('text', this.state.survey.reward)
                                    })}
                            }}

                            formControlProps={{
                                fullWidth: true
                            }}
                            error={this.state.textError1}
                        />
                        <CustomInput
                            labelText="Number of times the survey can be completed"
                            inputProps={{
                                defaultValue:survey&&survey.allowSurveyCompletionTimes?survey.allowSurveyCompletionTimes:10,
                                'aria-label': 'Campaign Rewards',
                                startAdornment:<InputAdornment position="start"></InputAdornment>,
                                onChange:(event)=>{
                                    let survey = this.state.survey
                                    survey.allowSurveyCompletionTimes= event.target.value
                                    let text2 = event.target.value
                                    this.setState({survey:survey,
                                    text2 : text2,
                                    textError2: validate('number', this.state.survey.allowSurveyCompletionTimes)
                                    })}
                            }}

                            formControlProps={{
                                fullWidth: true
                            }}
                            error={this.state.textError2}
                        />

                        <TextField
                            id="date"
                            label="Campaign End Date"
                            type="date"
                            value={survey&&survey.expiryDate?survey.expiryDate:""}
                            className={classes.textField}
                            onChange={(event)=>{
                                let survey = this.state.survey
                                survey.expiryDate= event.target.value
                                this.setState({survey:survey})

                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <div className={classes.questionSection}>
                            {isLoaded(questions)?
                                _.map(questions, (question,key)=>{
                                questionIndex++;
                                return(
                                    question?
                                        <ExpansionPanel className={classes.questionPanel} key={key}>
                                            <ExpansionPanelSummary className={classes.questionPanelSummary}  expandIcon={<ExpandMoreIcon />}>
                                            <h4 style={{color:"rgba(0, 0, 0, 0.54)",fontSize:14}}>Question {questionIndex+1} : {question.prompt} </h4>
                                            </ExpansionPanelSummary>
                                        <ExpansionPanelDetails>
                                        <div className={classes.questionPanelDetails}>
                                        <div className={classes.questionControls}>
                                        <QuestionTypeSelector value={question.type} onQuestionTypeChange={(type)=>{
                                        if(type!== question.type){
                                            if(type==="multiple"){
                                                questions[key]={type:type,options:[]}
                                            }
                                            if(type==="checkbox"){
                                                questions[key]={type:type,options:[]}
                                            }
                                            else if(type==="text"){
                                                questions[key]={type:type}
                                            }
                                            else if(type==="image"){
                                                questions[key]={type:type}
                                            }
                                            this.setState({questions:questions})

                                        }
                                          }}/>
                                        </div>                                      
                                            <div className={classes.questionContent}>
                                                {this.renderQuestionType(question,key)}
                                                <div> 
                                                    <Tooltip title="Delete Question" placement="bottom"  classes={{ tooltip: classes.lightTooltip }}>
                                                        <DeleteIcon style={{paddingTop: 15,marginRight:20,color:"rgba(0, 0, 0, 0.4)",cursor: "pointer",float:"right"}} onClick={() => this.openDeleteModal(key)}>Delete</DeleteIcon>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>

                                        </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                    :<div/>                                   
                                )
                            }):<LoadingSpinner/>
                            }
                        </div>
                    </div>
                    <div style={{margin:25,marginTop:30}} className={classes.surveyControls}>
                        <Button color="primary" onClick={this.addQuestion}>
                            Add Question
                        </Button>
                    </div>
                </Paper>:
                <div  style={{marginTop:"20%"}}>
                <LoadingSpinner/>
                </div>
             
            }
            {isSaving?
                <div/>:
                <div style={{marginLeft:40}}>
                    <FabButton variant="fab" className={classes.fab} color="primary"  onClick={this.saveSurvey}>
                        <SaveIcon/>
                </FabButton>
               </div>
            }
            <Dialog
            open={this.state.dialogOpen}
            onClose={this.handleClose}
            aria-labelledby="delete-dialog-title"
        >
            <DialogTitle id="delete-dialog-title">Delete Question</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete this question.
                </DialogContentText>

            </DialogContent>
            <DialogActions>
                <MaterialButton onClick={this.handleClose} color="primary">
                    Cancel
                </MaterialButton>
                    <MaterialButton onClick={this.deleteEmptyQuestion} color="primary">
                        {!this.state.isLoading ? "Delete": <LoadingSpinner/>}
                    </MaterialButton>:
            </DialogActions>
        </Dialog>
            </div>
        )
   
    }
}

const styles={
    lightTooltip: {
        background: "white",
        fontSize: 12,
        color:"rgba(0, 0, 0, 0.87)",
        boxShadow:"0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)"
      },
    paperContainer:{
        display:"flex",
        flexDirection:"column",
        width:"60%",
        minWidth:300
    },
    surveyHeaderBar:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"space-between",
        alignItems:"center"
    },
    questionPanel:{
      width:"100%"
    },
    questionPanelSummary:{
        margin:0,height: 60
      },
    questionPanelDetails:{
      display:"flex",
      flexDirection:"column",
      width:"100%"
    },
    surveyControls:{
      display:"flex",
      justifyContent:"flex-end",
      alignSelf:"flex-end",
      margin:10
    },
    surveyHeaderInput:{
        fontSize:40,
        width:"100%",
    },
    root:{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      marginTop:20
    },
    questionContainer:{
        margin:70
    },
    textField:{
        marginTop: "27px",
        width:"100%",
        paddingBottom: 10,
    },
    questionSection:{
        marginTop:50,
    },
    questionControls:{
        display:"flex",
        justifyContent:"flex-end"
    },
    errorColor: {
        marginRight: "auto",
        color:"#f44336",
      },


}
export default compose(
    withStyles(styles)
)(EditSurvey)


// WEBPACK FOOTER //
// ./src/views/Surveys/EditSurvey.jsx